import {AppReviewTasksActions} from "./model";
import {UpdateReviewTaskActions} from "./UpdateReviewTasks";
import {AppReviewActions} from "../../../static/reviewHistory/model";
import {errorMsg, successMsg} from "../../../../../../../components/simpleMessageAlert";
import {AlertMessage} from "../../../../../../../common/data/AlertMsg";
import {Dispatch} from "redux";

export type PostReviewTaskActions =
    PostBatchSaveReviewTaskAction
    | PostBatchSubmitReviewTaskAction
    | PostBatchClearReviewTaskAction
    | PostBatchTasksReassignmentAction

abstract class PostReviewTaskAction {
    abstract action: UpdateReviewTaskActions
    appId: string
    reviewId: string

    constructor(appId: string, reviewId: string) {
        this.appId = appId
        this.reviewId = reviewId
    }

    protected refreshOnUpdation(dispatch: Dispatch, tableNavigateFunction: Function): void {
        // @ts-ignore
        dispatch(AppReviewTasksActions.getReviewTasks({appId: this.appId, reviewId: this.reviewId})).then(() => {
                tableNavigateFunction()
                // @ts-ignore
                return dispatch(AppReviewActions.getReviewHistory(this.appId));
            }
        );
    }

    protected removeEditedReviewTasks(dispatch: Dispatch): void {
        dispatch(AppReviewTasksActions.removeEditedReviewTasks({reviewId: this.reviewId}))
    }

    protected displayErrorAlertMessage(): void {
        errorMsg(AlertMessage.submitReview.submittingSameRecordAfterReviewedByAnotherPerson, 10)
    }

    protected displaySuccessAlertMessage(): void {
        successMsg(AlertMessage.submitReview[this.action].success());
    }

    errorNotRelatedToReviewTasks(dispatch: Dispatch, tableNavigateFunction: Function) {
        this.refreshOnUpdation(dispatch, tableNavigateFunction)
    }
}

export class PostBatchSaveReviewTaskAction extends PostReviewTaskAction {
    action = UpdateReviewTaskActions.BatchSaveDecisionsRequest

    private successAlertMessage(updatedTasksSize: number): void {
        successMsg(AlertMessage.submitReview[this.action].success(updatedTasksSize));
    }

    error(dispatch: Dispatch, tableNavigateFunction: Function) {
        this.removeEditedReviewTasks(dispatch)
        this.displayErrorAlertMessage()
        this.refreshOnUpdation(dispatch, tableNavigateFunction)
    }

    success(dispatch: Dispatch, tableNavigateFunction: Function, updatedTasks: Array<string>) {
        this.removeEditedReviewTasks(dispatch);
        this.successAlertMessage(updatedTasks.length)
        this.refreshOnUpdation(dispatch, tableNavigateFunction)
    }
}

export class PostBatchSubmitReviewTaskAction extends PostReviewTaskAction {
    action = UpdateReviewTaskActions.BatchSubmitDecisionsRequest


    error(dispatch: Dispatch, tableNavigateFunction: Function) {
        this.removeEditedReviewTasks(dispatch)
        this.displayErrorAlertMessage()
        this.refreshOnUpdation(dispatch, tableNavigateFunction)
    }

    success(dispatch: Dispatch, tableNavigateFunction: Function) {
        this.displaySuccessAlertMessage()
        this.refreshOnUpdation(dispatch, tableNavigateFunction)
    }
}

export class PostBatchClearReviewTaskAction extends PostReviewTaskAction {
    action = UpdateReviewTaskActions.BatchClearDecisionsRequest

    private removeClearedReviewTask(dispatch: Dispatch, clearedReviewTasksIds: Array<string>) {
        dispatch(AppReviewTasksActions.removeEditedReviewTasksByTaskIdsIfExists({reviewTaskIds: clearedReviewTasksIds}))
    }

    error(dispatch: Dispatch, tableNavigateFunction: Function) {
        this.displayErrorAlertMessage()
        this.refreshOnUpdation(dispatch, tableNavigateFunction)
    }

    success(dispatch: Dispatch, tableNavigateFunction: Function, clearedReviewTasksIds: Array<string>) {
        this.removeClearedReviewTask(dispatch, clearedReviewTasksIds)
        this.displaySuccessAlertMessage()
        this.refreshOnUpdation(dispatch, tableNavigateFunction)
    }
}

export class PostBatchTasksReassignmentAction extends PostReviewTaskAction {
    action = UpdateReviewTaskActions.BatchTasksReassignmentRequest
    payload: object

    constructor(appId: string, reviewId: string, payload: object) {
        super(appId, reviewId)
        this.payload = payload
    }

    private successAlertMessage(updatedTasksSize: number): void {
        successMsg(AlertMessage.submitReview[this.action].success(updatedTasksSize, this.payload));
    }

    error(dispatch: Dispatch, tableNavigateFunction: Function, count: number) {
        errorMsg(AlertMessage.submitReview[this.action].error(count), 10)
        this.refreshOnUpdation(dispatch, tableNavigateFunction)
    }

    success(dispatch: Dispatch, tableNavigateFunction: Function, updatedTasks: Array<string>) {
        this.successAlertMessage(updatedTasks.length)
        this.refreshOnUpdation(dispatch, tableNavigateFunction)
    }
}